import Vue from "vue";
import { API } from "./config";
import router from "./router";
import http from "@/http";

const state = Vue.observable({
  user: null,
  auth: null,
});

const setAuth = (auth) => {
  state.auth = auth;
  if (auth) {
    localStorage.setItem("loggedIn", true);
  } else {
    localStorage.removeItem("loggedIn");
  }
};

export default {
  get: {
    user: () => state.user,
    auth: () => state.auth,
  },
  set: {
    user: (user) => (state.user = user),
    auth: setAuth,
  },
  actions: {
    refreshToken() {
      function refetch() {
        setTimeout(() => {
          if (!state.auth) return;

          http
            .get(`${API}/refresh-token`, { credentials: "include" })
            .then((res) => {
              state.user = res.user;
              setAuth(res.auth);
              refetch();
            })
            .catch(() => {
              state.user = null;
              setAuth(null);
            });
        }, 14.5 * 60 * 1000); // 14.5min
        // }, 5 * 1000); // 5sec
      }
      refetch();
    },

    logout() {
      return http.get(`${API}/logout`, { credentials: "include" }).then(() => {
        state.user = null;
        setAuth(null);
        router.push("/");
      });
    },
  },
};

// export const get = {
//   user: () => state.user,
//   auth: () => state.auth,
// };

// export const set = {
//   user: (user) => (state.user = user),
//   auth: (auth) => (state.auth = auth),
// };
